'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colSpan = require('./col-span.js');
var colStart = require('./col-start.js');
var gridCols = require('./grid-cols.js');

const tailwind = {
    colSpan: colSpan.dynamicColSpan,
    colStart: colStart.dynamicColStart,
    gridCols: gridCols.dynamicGridCols
};

exports.default = tailwind;
exports.tailwind = tailwind;
//# sourceMappingURL=index.js.map
